/*
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const RatingPage = () => {
  const { orderId } = useParams();
  const navigate = useNavigate();

  const [orderDetails, setOrderDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [rating, setRating] = useState(0);
  const [hoveredRating, setHoveredRating] = useState(0);
  const [review, setReview] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      const mockOrder = {
        id: orderId || 'ORD-1234',
        date: '2025-04-10T18:30:00',
        restaurant: {
          id: 'rest-1',
          name: 'Pizza Palace',
          image: '/assets/images/c25.png',
        },
        items: [
          { name: 'Margherita Pizza', quantity: 1, price: 12.99 },
          { name: 'Garlic Breadsticks', quantity: 1, price: 4.99 }
        ],
        status: 'Delivered',
        total: 17.98
      };

      setOrderDetails(mockOrder);
      setLoading(false);
    }, 1000);
  }, [orderId]);

  const handleStarHover = (star) => setHoveredRating(star);
  const handleStarClick = (star) => setRating(star);
  const handleStarLeave = () => setHoveredRating(0);
  const handleReviewChange = (e) => setReview(e.target.value);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (rating === 0) {
      alert('Please select a star rating');
      return;
    }
    setSubmitting(true);
    setTimeout(() => {
      setSubmitting(false);
      setSubmitted(true);
      setTimeout(() => navigate('/order-history'), 3000);
    }, 1500);
  };

  const renderStars = () => (
    <div className="stars-container" onMouseLeave={handleStarLeave}>
      {[1, 2, 3, 4, 5].map((star) => (
        <span
          key={star}
          className={`star-icon ${star <= (hoveredRating || rating) ? 'active' : ''}`}
          onMouseEnter={() => handleStarHover(star)}
          onClick={() => handleStarClick(star)}
        >
          <i className="fas fa-star"></i>
        </span>
      ))}
    </div>
  );

  if (loading) {
    return (
      <div className="rating-page">
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p>Loading order details...</p>
        </div>
      </div>
    );
  }

  if (submitted) {
    return (
      <div className="rating-page">
        <div className="success-container">
          <div className="success-icon">
            <i className="fas fa-check-circle"></i>
          </div>
          <h2>Thank You for Your Feedback!</h2>
          <p>Your rating and review have been submitted successfully.</p>
          <p>Redirecting to order history...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="rating-page">
      <div className="page-header">
        <h1>Rate Your Experience</h1>
        <p>Let us know how we did with your order</p>
      </div>

      <div className="rating-container">
        <div className="order-summary">
          <div className="restaurant-info">
            <div className="restaurant-image">
              <i className="fas fa-utensils"></i>
            </div>
            <h3>{orderDetails.restaurant.name}</h3>
          </div>

          <div className="order-details">
            <div className="order-item">
              <span className="item-label">Order ID:</span>
              <span className="item-value">{orderDetails.id}</span>
            </div>
            <div className="order-item">
              <span className="item-label">Date:</span>
              <span className="item-value">
                {new Date(orderDetails.date).toLocaleDateString()}
              </span>
            </div>
            <div className="order-items">
              <span className="item-label">Items:</span>
              <div className="items-list">
                {orderDetails.items.map((item, index) => (
                  <div key={index} className="food-item">
                    {item.quantity} × {item.name}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        <form className="rating-form" onSubmit={handleSubmit}>
          <div className="form-section">
            <h3>How would you rate your experience?</h3>
            {renderStars()}
            <div className="rating-text">
              {rating === 1 && 'Poor'}
              {rating === 2 && 'Fair'}
              {rating === 3 && 'Good'}
              {rating === 4 && 'Very Good'}
              {rating === 5 && 'Excellent'}
            </div>
          </div>

          <div className="form-section">
            <h3>Share your thoughts (optional)</h3>
            <textarea
              className="review-textarea"
              placeholder="Tell us what you liked or what we could improve..."
              value={review}
              onChange={handleReviewChange}
              rows="5"
            ></textarea>
          </div>

          <div className="form-actions">
            <button
              type="button"
              className="btn btn-outline"
              onClick={() => navigate('/order-history')}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn btn-primary"
              disabled={submitting}
            >
              {submitting ? 'Submitting...' : 'Submit Review'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default RatingPage;
*/
/*code updated */
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const RatingPage = () => {
  const { orderId } = useParams(); // Get the order ID from URL
  const navigate = useNavigate();

  // State to store order details and review form data
  const [orderDetails, setOrderDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [rating, setRating] = useState(0);
  const [hoveredRating, setHoveredRating] = useState(0);
  const [review, setReview] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  // Simulate API fetch for order details using static data
  useEffect(() => {
    setTimeout(() => {
      // Static/mock data (replace with API data later)
      const mockOrder = {
        id: orderId || 'ORD-1234',
        date: '2025-04-10T18:30:00',
        restaurant: {
          id: 'rest-1',
          name: 'Pizza Palace',
          image: '/assets/images/c25.png',
        },
        items: [
          { name: 'Margherita Pizza', quantity: 1, price: 12.99 },
          { name: 'Garlic Breadsticks', quantity: 1, price: 4.99 }
        ],
        status: 'Delivered',
        total: 17.98
      };

      setOrderDetails(mockOrder);
      setLoading(false);
    }, 1000); // Simulate network delay
  }, [orderId]);

  // Handlers for star rating interaction
  const handleStarHover = (star) => setHoveredRating(star);
  const handleStarClick = (star) => setRating(star);
  const handleStarLeave = () => setHoveredRating(0);
  const handleReviewChange = (e) => setReview(e.target.value);

  // Handle review form submission
  const handleSubmit = (e) => {
    e.preventDefault();

    if (rating === 0) {
      alert('Please select a star rating');
      return;
    }

    setSubmitting(true);

    // Simulate submitting review to server
    setTimeout(() => {
      setSubmitting(false);
      setSubmitted(true);
      setTimeout(() => navigate('/order-history'), 3000); // Redirect after success
    }, 1500);
  };

  // Render star icons for rating
  const renderStars = () => (
    <div className="stars-container" onMouseLeave={handleStarLeave}>
      {[1, 2, 3, 4, 5].map((star) => (
        <span
          key={star}
          className={`star-icon ${star <= (hoveredRating || rating) ? 'active' : ''}`}
          onMouseEnter={() => handleStarHover(star)}
          onClick={() => handleStarClick(star)}
        >
          <i className="fas fa-star"></i>
        </span>
      ))}
    </div>
  );

  // Show loading spinner while fetching order data
  if (loading) {
    return (
      <div className="rating-page">
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p>Loading order details...</p>
        </div>
      </div>
    );
  }

  // Show success message after review submission
  if (submitted) {
    return (
      <div className="rating-page">
        <div className="success-container">
          <div className="success-icon">
            <i className="fas fa-check-circle"></i>
          </div>
          <h2>Thank You for Your Feedback!</h2>
          <p>Your rating and review have been submitted successfully.</p>
          <p>Redirecting to order history...</p>
        </div>
      </div>
    );
  }

  // Main rating form and order summary
  return (
    <div className="rating-page">
      <div className="page-header">
        <h1>Rate Your Experience</h1>
        <p>Let us know how we did with your order</p>
      </div>

      <div className="rating-container">
        {/* Order summary section */}
        <div className="order-summary">
          <div className="restaurant-info">
            <div className="restaurant-image">
              <i className="fas fa-utensils"></i>
            </div>
            <h3>{orderDetails.restaurant.name}</h3>
          </div>

          <div className="order-details">
            <div className="order-item">
              <span className="item-label">Order ID:</span>
              <span className="item-value">{orderDetails.id}</span>
            </div>
            <div className="order-item">
              <span className="item-label">Date:</span>
              <span className="item-value">
                {new Date(orderDetails.date).toLocaleDateString()}
              </span>
            </div>
            <div className="order-items">
              <span className="item-label">Items:</span>
              <div className="items-list">
                {orderDetails.items.map((item, index) => (
                  <div key={index} className="food-item">
                    {item.quantity} × {item.name}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Review form section */}
        <form className="rating-form" onSubmit={handleSubmit}>
          <div className="form-section">
            <h3>How would you rate your experience?</h3>
            {renderStars()}
            <div className="rating-text">
              {rating === 1 && 'Poor'}
              {rating === 2 && 'Fair'}
              {rating === 3 && 'Good'}
              {rating === 4 && 'Very Good'}
              {rating === 5 && 'Excellent'}
            </div>
          </div>

          <div className="form-section">
            <h3>Share your thoughts (optional)</h3>
            <textarea
              className="review-textarea"
              placeholder="Tell us what you liked or what we could improve..."
              value={review}
              onChange={handleReviewChange}
              rows="5"
            ></textarea>
          </div>

          <div className="form-actions">
            <button
              type="button"
              className="btn btn-outline"
              onClick={() => navigate('/order-history')}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn btn-primary"
              disabled={submitting}
            >
              {submitting ? 'Submitting...' : 'Submit Review'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default RatingPage;
